export const DEFAULT_LIMIT_NUMBER_OF_EVENTS = 100;

export enum MatchTabsIds {
    Score = 'score',
    MatchDescription = 'matchDescription',
    Statistics = 'statistics',
    LiveTV = 'liveTV',
    Visualization= 'visualization',
}

export const refId = 'CheckBetradarLicenseError';

export enum PerformanceLoadingThresholds {
    SLOW_LOAD_MS = 3500
  }